import { render, staticRenderFns } from "./smd_quote.vue?vue&type=template&id=2b88a660&scoped=true&"
import script from "./smd_quote.vue?vue&type=script&lang=js&"
export * from "./smd_quote.vue?vue&type=script&lang=js&"
import style0 from "./smd_quote.vue?vue&type=style&index=0&id=2b88a660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88a660",
  null
  
)

export default component.exports